import {format} from "date-fns/format";


 const utils = {
    formatFromDate(
        date: Date,
        formatString: string = "yyyy-MM-dd HH:mm"
    ): string {
        return format(date, formatString);
    }
}

export default utils;